import clamp from 'lodash/clamp';

const validate = (color: number[]) =>
  Array.from({length: 3}, (_, i) => clamp(color[i] ?? 0, 0, 255));

export const convertRgbArrayToHex = (color: number[]) => {
  const normalised = validate(color);

  const result = normalised.map(c => c.toString(16).padStart(2, '0')).join('');

  return `#${result}`;
};
